export enum ESidebarTabs {
  COMMENTS = 'Comments',
  INFO = 'Info',
}
